import PointPopup from '@/views/maps/popup/PointPopup'
import lineConfig from './lineConfig'
import L from 'leaflet'
import Vue from 'vue'
import { ref } from '@vue/composition-api'


export default function route() {

  const marker = ref(null)
  const info = Vue.extend(PointPopup)
  const routeLayer = L.layerGroup()
  const line = new L.Polyline([], lineConfig)

  let icons = []
  let lastPointStatus = ''


  const initNewPopup = p => {
    const pop = new info({
      propsData: {
        point: {
          speed: p.speed,
          time: p.devicetime,
          status: p.status
        }
      }
    })

    pop.$mount()
    return pop.$el
  }


  const initDevice = p => {
    const pop = initNewPopup(p)

    let img;

    try {
      img = require('@/assets/markers/'+p.category+'/'+p.status+'.svg')
    } catch (e) {
      img = require('@/assets/markers/'+p.status+'.svg')
    }

    const icon = L.divIcon({
      html: L.Util.template(`<img src="${img}" alt="${p.status}">`),
      iconSize    : [20, 30], })
    const latlng = new L.LatLng(p.latitude, p.longitude)
   return L.marker(latlng, {icon: icon}).bindPopup(pop)
  }


  /**
   *
   * @param data
   * @param map
   */
  const drawLine = (data, map) => {

    const points = data.points

    if (points.length < 1) return

    let ps = []

    marker.value = initDevice({...points[0], ...data.device})
    routeLayer.addLayer(marker.value)

    points.map(p => {

      ps.push([parseFloat(p.latitude), parseFloat(p.longitude)])

      if (!icons.includes(p.status)) {
        icons[p.status] = require('@/assets/points/'+p.status+'.svg')
      }

      if (lastPointStatus !== p.status) {

        lastPointStatus = p.status
        const pop = initNewPopup(p)

        const icon = L.divIcon({
          html: L.Util.template(`<img src="${icons[p.status]}" alt="${p.status}">`),
          iconSize    : [20, 30], })

        const m = L.marker([parseFloat(p.latitude), parseFloat(p.longitude)], {icon: icon})
          .bindPopup(pop)

        routeLayer.addLayer(m)
      }
    })

    line.setLatLngs(ps)
    routeLayer.addLayer(line)
    routeLayer.addTo(map)
    map.fitBounds(line.getBounds())

  }


  const clearRoute = () => {
    routeLayer.clearLayers()
  }


  return {
    clearRoute,
    routeLayer,
    marker,
    line,
    drawLine
  }
}
